import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { logError } from "@faire/web--source/common/logging";
import getShouldDisplayPasswordModal from "@faire/web-api--source/api/v2/users/display-password-modal/get";
import { useQuery as useShouldResetPasswordQuery } from "@faire/web-api--source/api/v2/users/display-password-modal/get-hooks";
export var useShouldDisplayResetPasswordAfterLogin = function() {
    var _useShouldResetPasswordQuery = useShouldResetPasswordQuery(), data = _useShouldResetPasswordQuery.data, isLoading = _useShouldResetPasswordQuery.isLoading;
    var _data_should_display_password_modal;
    var shouldShowResetPassword = (_data_should_display_password_modal = data === null || data === void 0 ? void 0 : data.should_display_password_modal) !== null && _data_should_display_password_modal !== void 0 ? _data_should_display_password_modal : false;
    return {
        shouldShowResetPassword: shouldShowResetPassword,
        isLoading: isLoading
    };
};
export var fetchShouldDisplayResetPasswordAfterLogin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var response, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getShouldDisplayPasswordModal()
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.should_display_password_modal
                    ];
                case 2:
                    error = _state.sent();
                    logError(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function fetchShouldDisplayResetPasswordAfterLogin() {
        return _ref.apply(this, arguments);
    };
}();
